import { Store } from './createStore';
import { ActionType, Action, State } from './state';
import { OnNewMessageSubscription } from './documents/onNewMessageSubscription.generated';
import { OnMessageUpdateSubscription } from './documents/onMessageUpdateSubscription.generated';
import { OnNewConversationSubscription } from './documents/onNewConversationSubscription.generated';

export function createOnNewMessage(store: Store<State, Action>) {
    return function onNewMessage(data: OnNewMessageSubscription) {
        if (data?.onNewMessage) {
            store.dispatch({
                type: ActionType.NEW_MESSAGE,
                payload: data.onNewMessage,
            });
        }
    };
}

export function createOnMessageUpdate(store: Store<State, Action>) {
    return function onMessageUpdate(data: OnMessageUpdateSubscription) {
        if (data?.onMessageUpdate) {
            store.dispatch({
                type: ActionType.UPDATE_MESSAGE,
                payload: data.onMessageUpdate,
            });
        }
    };
}

export function createOnNewConversation(store: Store<State, Action>) {
    return function onNewConversation(data: OnNewConversationSubscription) {
        if (data?.onNewConversation) {
            const conversation = data.onNewConversation;

            if (conversation.newestMessage) {
                store.dispatch({
                    type: ActionType.NEW_MESSAGE,
                    payload: {
                        ...conversation.newestMessage,
                        conversationUuid: conversation.uuid,
                    },
                });
            }

            store.dispatch({
                type: ActionType.NEW_CONVERSATION,
                payload: conversation,
            });
        }
    };
}
